import React from "react";
import axios from "axios";
import { environment } from "../../environments/environment";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { WebsiteFooter } from "../../components/website-footer";
import { WebsiteHeader } from "../../components/website-header";
import InputField from "../../components/InputField";
import { RxPerson } from "react-icons/rx";
import { CiMail } from "react-icons/ci";
import { RiPhoneFill, RiUserFill } from "react-icons/ri";
import logo from "../../assets/logo.svg";
import { BlackButton } from "../../components/black-button";
import { Formik, FormikHelpers, Form, Field } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import api from "../../api/api";

export const AdminSignup = () => {
  const navigate = useNavigate();

  const handleSubmit = async (
    values: any,
    { setSubmitting }: FormikHelpers<any>
  ) => {
    try {
      const response = await api.post(
        `${environment.baseUrl}/admin/auth/signup`,
        {
          email: values.email,
          phone: values.phone,
          username: values.username,
          name: values.name,
        }
      );

      if (response.data.success) {
        // notify success
        toast.success(response.data.message);
        localStorage.setItem("uuid_to_verify", response.data.data.uuid);
        navigate("/admin/verify");
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    username: Yup.string().required("Username is required"),
    phone: Yup.string().required("Phone number is required"),
  });

  return (
    <>
      <nav className="web_padding_x Navbar pt-8 pb-6 flex gap-8 2xl:gap-10 items-center whitespace-nowrap overflow-x-hidden">
        <NavLink to="/">
          <img src={logo} className="logo w-[100px] md:w-[180px]" alt="LOGO" />
        </NavLink>
      </nav>

      <section className="web_padding_y web_padding_x">
        <Formik
          initialValues={{
            email: "",
            phone: "",
            username: "",
            name: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isValid, values, isSubmitting }) => (
            <Form className="w-full max-w-[550px]">
              <h2 className="bar_above web_heading">Create An Account</h2>
              <div className="flex flex-col items-start gap-4 mt-6 tall:mt-10 2xl:mt-10">
                <InputField
                  label="Name"
                  name="name"
                  placeholder="Luudu"
                  type="text"
                  icon={<RxPerson />}
                  required={true}
                />
                <InputField
                  label="Email"
                  name="email"
                  placeholder="luudu@gmail.com"
                  type="email"
                  icon={<CiMail />}
                  required={true}
                />
                <InputField
                  name="username"
                  label="Username"
                  type="text"
                  placeholder="username"
                  icon={<RiUserFill />}
                  required={true}
                />
                <Field name="phone">
                  {({ field, form }: any) => (
                    <div className="grid grid-cols-[85px_1fr] w-full">
                      <label htmlFor="phone">Phone</label>
                      <PhoneInput
                        {...field}
                        onChange={(value) => form.setFieldValue("phone", value)}
                        inputClass="!w-full p !border-black !rounded-[20px] md:!rounded-[27px]"
                      />
                    </div>
                  )}
                </Field>
                <div className="max-w-[350px] w-full">
                  <BlackButton
                    className="w-full"
                    text="Sign up"
                    type="submit"
                    isDisabled={!isValid || !values.email || !values.phone}
                    isLoading={isSubmitting}
                  ></BlackButton>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </section>
      <WebsiteFooter />
    </>
  );
};
